module.exports = __webpack_public_path__ + "static/media/empty_scene.28420005.png";